import Vue from 'vue';
import Vuetify, { Ripple } from 'vuetify/lib';
import { globalIcons } from '../mixins/style/icon-mixins';

Vue.use(Vuetify, { directives: { Ripple } });

// Green (G00)
const green = {
	base: '#6B9166',
	lighten1: '#81B37B',
	lighten2: '#BBD8BB',
	lighten3: '#D5E7D4',
	darken1: '#61805D',
	darken2: '#505F4E',
};

const lime = '#DCFA6E';
const kimberly = '#666B91';

const offWhite = '#F2F1E7';
const mono50 = '#FAFAFA';
const mono200 = '#EFEFEF';
const mono300 = '#E1E1E1';
const mono500 = '#9F9F9F';
const mono700 = '#626262';
const mono800 = '#434343';
const mono900 = '#222222';

const yellow = '#FACD3C';
const purple = {
	base: '#C8B4FA',
	lighten1: '#F2EDFD',
	darken1: '#B194F7',
	darken2: '#8B62EC',
	darken3: '#7253DA',
	darken4: '#5240C3',
};

export default new Vuetify({
	theme: {
		options: { customProperties: true },
		themes: {
			light: {
				primary: green,

				//used for tab text
				anchor: green.darken2,
				anchorBg: green.lighten3,

				anchorInactive: mono900,
				anchorInactiveBg: offWhite,

				//used for fishball, job/event next button
				secondary: mono800,

				accent: green.darken1,
				background: 'transparent', //vuetify variable, used by login page

				//used for error, or critical actions like reject/delete
				error: '#C81414',
				disabled: mono300,

				border: mono700,

				info: '#B4B4B4',
				success: '#007800',
				warning: '#DEA402',

				badge: lime,

				offWhite,
				mono50,
				mono200,
				mono300,
				mono500,
				mono700,
				mono800,
				mono900,

				snackbarSuccessBackground: '#F1F4F0',
				snackbarErrorBackground: '#FAE8E8',
				snackbarWarningBackground: '#FCF6E6',

				green,
				peach: '#FA9470',
				darkPeach: '#E25C28', // not to use darken-1, could break existing styling

				kimberly,
				yellow,
				purple,
			},
		},
	},
	icons: {
		values: globalIcons,
	},
	// lang: {
	// 	t: (key, ...params) => String(i18n.t(key, params)),
	// },
});
